module.exports = __webpack_public_path__ + "plazmaterapie_01_20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akce/plazmaterapie_01_20.jpg
// module id = 843
// module chunks = 0